/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Project } from './Project';
import {
    ProjectFromJSON,
    ProjectFromJSONTyped,
    ProjectToJSON,
} from './Project';

/**
 * 
 * @export
 * @interface BuilderInfoProjectRolesValue
 */
export interface BuilderInfoProjectRolesValue {
    /**
     * The role of the builder in the project.
     * @type {string}
     * @memberof BuilderInfoProjectRolesValue
     */
    role: string;
    /**
     * The type of the principal.
     * @type {string}
     * @memberof BuilderInfoProjectRolesValue
     */
    principalType: BuilderInfoProjectRolesValuePrincipalTypeEnum;
    /**
     * The ID of the team or builder.
     * @type {string}
     * @memberof BuilderInfoProjectRolesValue
     */
    principalId: string;
    /**
     * 
     * @type {Project}
     * @memberof BuilderInfoProjectRolesValue
     */
    project: Project;
}


/**
 * @export
 */
export const BuilderInfoProjectRolesValuePrincipalTypeEnum = {
    Team: 'team',
    Builder: 'builder'
} as const;
export type BuilderInfoProjectRolesValuePrincipalTypeEnum = typeof BuilderInfoProjectRolesValuePrincipalTypeEnum[keyof typeof BuilderInfoProjectRolesValuePrincipalTypeEnum];


/**
 * Check if a given object implements the BuilderInfoProjectRolesValue interface.
 */
export function instanceOfBuilderInfoProjectRolesValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "principalType" in value;
    isInstance = isInstance && "principalId" in value;
    isInstance = isInstance && "project" in value;

    return isInstance;
}

export function BuilderInfoProjectRolesValueFromJSON(json: any): BuilderInfoProjectRolesValue {
    return BuilderInfoProjectRolesValueFromJSONTyped(json, false);
}

export function BuilderInfoProjectRolesValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuilderInfoProjectRolesValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': json['role'],
        'principalType': json['principalType'],
        'principalId': json['principalId'],
        'project': ProjectFromJSON(json['project']),
    };
}

export function BuilderInfoProjectRolesValueToJSON(value?: BuilderInfoProjectRolesValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': value.role,
        'principalType': value.principalType,
        'principalId': value.principalId,
        'project': ProjectToJSON(value.project),
    };
}

